import { useTranslation } from 'react-i18next'
import { shareStateFor, useLiveShare } from '../data/livePosition.ts'
import { Picto } from './pictos.tsx'
import { isNative } from '../platform/native.ts'

/** Said while a timer of the person runs: their position is shared with the team (or why it is not). Nothing is said when nothing is shared. The work
 *  page names its session (shown only for the viewer's OWN running session), Today speaks for all of the person's running ones. The native app says
 *  that the sharing goes on with the screen off (M19b): a browser's stops when the page is hidden. */
export function LiveShareBanner({ sessionId }: { sessionId?: string }) {
  const { t } = useTranslation()
  const state = shareStateFor(useLiveShare(), sessionId)
  if (state === 'off') return null
  const tone = state === 'sharing'
    ? 'border-sky-300 bg-sky-50 text-sky-950 dark:border-sky-700 dark:bg-sky-950/40 dark:text-sky-100'
    : 'border-amber-400 bg-amber-50 text-amber-950 dark:border-amber-600 dark:bg-amber-950/40 dark:text-amber-100'
  return (
    <p className={`flex items-center gap-2 rounded-xl border-2 px-3 py-2 text-sm font-medium ${tone}`} role="status" data-testid="live-share" data-state={state}>
      <Picto name="people" className="size-5 shrink-0" />
      <span>{state === 'sharing' && isNative() ? t('live.share.sharingNative') : t(`live.share.${state}`)}</span>
    </p>
  )
}
